import { createActions } from 'redux-actions'
import { User, Role } from '../../../types'

export const {
  auth: { updateUser },
} = createActions({
  '@auth/updateUser': (user: User, role: Role, menu: any) => ({
    user,
    role,
    menu,
  }),
})
